<template>
    <div class="design-flow-wrapper">
        <div class="main-content-grid">
            <LeftSidebar v-if="!$route.meta.hideNav" />
            <div class="main-scroll-area">
                <router-view v-slot="{ Component }">
                    <transition :name="$route.meta.transition || 'slide-left'">
                        <component :is="Component" />
                    </transition>
                </router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, provide } from 'vue'
import LeftSidebar from '@/components/LeftSidebar.vue'
export default {
    name: 'VoiceDesignWorkflow',
    components: { LeftSidebar },

    setup() {
        const sharedData = ref({})
        provide('sharedData', sharedData)
    }
}
</script>

<style scoped>
.main-content-grid {
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 112px 1fr;
    height: 100%;
    min-height: 0;
}

.slide-left-enter-active,
.slide-left-leave-active {
    transition: transform 0.3s ease;
}

.slide-left-enter-from {
    transform: translateX(100%);
}

.slide-left-enter-to {
    transform: translateX(0);
}

.slide-left-leave-from {
    transform: translateX(0);
}

.slide-left-leave-to {
    transform: translateX(-100%);
}

/* Back (previous) */
.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.3s ease;
}

.slide-right-enter-from {
    transform: translateX(-100%);
}

.slide-right-enter-to {
    transform: translateX(0);
}

.slide-right-leave-from {
    transform: translateX(0);
}

.slide-right-leave-to {
    transform: translateX(100%);
}

.design-flow-wrapper {
    height: 100vh;
}
</style>
